module.exports = __webpack_public_path__ + "static/media/TransparentLogo.7d24e66c.ico";